import { configureStore, combineReducers } from "@reduxjs/toolkit";
import accountListReducer from "../features/accountListSlice";
import authReducer from "./authRedux";
import apiReducer from "./apiRedux";
import bodyPartReducer from "./bodyPart/bodyPartSlice";
import refundRequestReducer from "./refundRequest/filterSlice";
import voucherReducer from "./voucher/voucherSlice";
import accountReducer from "./account/accountSlice";
import dateReducer from "./dateSlice";
import purchaseHistoryReducer from "./purchaseHistory/filterSlice";
import featureToggleReducer from "./featureToggleSlice";
import saleReturnReducer from "./saleReturn/saleReturnSlice";
import refundListReducer from "./refundList/refundListSlice";

import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  version: 2,
  storage,
};

const rootReducer = combineReducers({
  auth: authReducer,
  api: apiReducer,
  bodyPart: bodyPartReducer,
  voucher: voucherReducer,
  date: dateReducer,
  refundRequest: refundRequestReducer,
  accountList: accountReducer,
  purchaseHistory: purchaseHistoryReducer,
  featureToggle: featureToggleReducer,
  saleReturn: saleReturnReducer,
  refundList: refundListReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  accountList: accountListReducer,
});

export let persistor = persistStore(store);
